<template>
    <div class="contact">
      <p class="bg"></p>

      <contactUs></contactUs>
      <p class="bg"></p>

    </div>
</template>

<script>
  import contactUs from "../../components/contactUs/contactUs";
    export default {
        name: "contact",
        components:{
            contactUs
        },
    }
</script>

<style scoped>
  .contact{
    background: #1e2432;
  }
  .bg{
    background: #1e2432;
height: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/contact/contact.vue